import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { injectQuery } from '@tanstack/angular-query-experimental';

import DataRefService from './dataRef.service';

export function injectCountriesQuery() {
  const dataRefService = inject(DataRefService);
  const translateService = inject(TranslateService);
  return injectQuery(() => ({
    queryKey: ['countries', translateService.currentLang],
    queryFn: () => dataRefService.getCountries(),
    staleTime: Infinity,
  }));
}
